// One "Zurücksetzen" per sheet (top right): returns the patch back to the sheet's defaults, or null when nothing deviates.
const metaPatch = (o, values) => ({ meta: { ...(o.meta || {}), ...values } });
const differs = (o, values) => Object.entries(values).some(([k, v]) => (o[k] ?? v) !== v);

export function resetPatch(sheet, o, textile) {
  const m = o.meta || {};
  switch (sheet) {
    case 'rotation': return o.rotation ? { rotation: 0 } : null;
    case 'mirror': return o.flipX || o.flipY ? { flipX: false, flipY: false } : null;
    case 'curve': return o.curve ? { curve: 0 } : null;
    case 'size': return (m.stretch_x || 1) !== 1 || (m.stretch_y || 1) !== 1 ? metaPatch(o, { stretch_x: 1, stretch_y: 1 }) : null;
    case 'warp': return (m.warp && m.warp !== 'none') || m.skew ? metaPatch(o, { warp: 'none', skew: 0, fill_warp: false }) : null;
    case 'format': { const d = { letterSpacing: 0, lineHeight: 1.2, align: 'center', uppercase: false }; return differs(o, d) ? d : null; }
    case 'tone': return o.type === 'image' ? (o.brightness || o.contrast ? { brightness: 0, contrast: 0 } : null) : (o.lightness ? { lightness: 0 } : null);
    case 'color': return textile && ((m.color && m.color.toLowerCase() !== '#111111') || m.gradient?.length > 1 || m.fill_image) ? metaPatch(o, { color: '#111111', gradient: [], fill_image: null }) : null;
    case 'shape': return (o.shape && o.shape !== 'rect') || o.frameOutline ? { shape: 'rect', frameOutline: false } : null;
    case 'style': return !textile && o.type === 'text' && (o.outline || o.engraveStyle) ? { outline: false, engraveStyle: null } : null;
    default: return null;
  }
}
